class UrgencyTimer {
  constructor() {
    this.urgencyTimer = null;
  }

  initUrgencyTimer(element) {
    if (!element) {
      return;
    }
    if (this.urgencyTimer === element) {
      return;
    }
    this.urgencyTimer = element;

    const storage = localStorage.getItem("urgencyTimer");
    let storageData = null;
    if (storage) {
      storageData = JSON.parse(storage);
    }
    const remaining = storageData ? this.getRemaining(storageData.startTime) : 0;
    if (storageData && remaining > 0) {
      this.urgencyTimerStartTime = storageData.startTime;
    } else {
      this.urgencyTimerStartTime = Date.now();
      storageData = {
        startTime: this.urgencyTimerStartTime,
      };
      localStorage.setItem("urgencyTimer", JSON.stringify(storageData));
    }

    this.urgencyTimerId = setInterval(this.updateUrgencyTimer.bind(this), 1000);

    this.updateUrgencyTimer();
  }

  getRemaining(startTime) {
    const time = Date.now();
    const passed = Math.trunc((time - startTime) / 1000);
    const remaining = this.urgencyTimer.dataset.seconds - passed;
    return remaining;
  }

  updateUrgencyTimer() {
    let remaining = this.getRemaining(this.urgencyTimerStartTime);
    if (remaining < 0) {
      // just stop the timer
      remaining = 0;
      clearInterval(this.urgencyTimerId);
      this.urgencyTimerId = null;
    }
    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;

    // we have fixed width divs inside to ensure monospace-ness. in plain text it was flicking/shifting when narrower digits.
    // this.urgencyTimer.textContent = text;
    const digits = [];
    digits[0] = Math.trunc(minutes / 10);
    digits[1] = minutes % 10;
    digits[2] = ":";
    digits[3] = Math.trunc(seconds / 10);
    digits[4] = seconds % 10;

    for (var i = 0; i < 5; i++) {
      this.urgencyTimer.children.item(i).textContent = digits[i];
    }
  }

  resetUrgencyTimer() {
    if (this.urgencyTimerId !== null) {
      clearInterval(this.urgencyTimerId);
      this.urgencyTimerId = null;
    }
    localStorage.removeItem("urgencyTimer");
  }
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.urgencyTimer = new UrgencyTimer();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');

    this.reinitUrgencyTimer();

    savePreCheckoutUrl();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, silent = false) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (!silent) this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  reinitUrgencyTimer() {
    const cartItems = document.querySelector('cart-drawer-items');
    if (!cartItems) return;

    if (cartItems.currentItemCount > 0) {
      this.urgencyTimer.initUrgencyTimer(document.querySelector(".js-urgency-timer"));
      this.setFeaturesIfTbyb();
    } else {
      this.urgencyTimer.resetUrgencyTimer();
    }
  }

  setFeaturesIfTbyb() {
    const tbybFeaturesElement = this.querySelector('.drawer__features-tbyb');
    const nonTbybFeaturesElement = this.querySelector('.drawer__features-nontbyb');
    
    if (!tbybFeaturesElement) return;

    const cartItems = document.querySelector('cart-drawer-items');
    if (!cartItems) return;

    if (cartItems.querySelector("button.tbyb-tag")) {
      tbybFeaturesElement.classList.remove('hidden');
      nonTbybFeaturesElement.classList.add('hidden');
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
